const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@conalepmex\.edu\.mx$/;
const NAME_REGEX = /^(?! )(?!.* $)[a-zA-ZáéíóúÁÉÍÓÚñÑ]+(?: [a-zA-ZáéíóúÁÉÍÓÚñÑ]+)?$/;
const DIGIT=/^\d$/;
const IS_VARIABLE = /^[a-zA-Z]/;

export const emailValidate = (email) => { 
    return EMAIL_REGEX.test(email);
};
export const nameValidate = (name) => {
    return NAME_REGEX.test(name);
};
export const isDigitValidate = (digit) => {
    return DIGIT.test(digit);
};
export const isVariableValidate = (variable) => {
    return IS_VARIABLE.test(variable);
}